import React from 'react'

import styles from './ApplicationBootstrapFallback.scss'

/**
 * Full-viewport fallback for application-level Suspense boundaries.
 */
const ApplicationBootstrapFallback = () => (
  <div className={styles.fallback} role="status" aria-live="polite" aria-busy="true" aria-label="Loading application">
    <div className={styles.spinner} />
  </div>
)

export default ApplicationBootstrapFallback
